import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1l": "#FF0000",
    "col1n": "#C40000",
    "col2d": "#008300",
    "col2n": "#00B600"
}
function ObjFoo065({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M41.15 17q3.25-5.25 3.5-10.25V5.7l-.05.05q-.1-2.2-2.75-3.9Q39.05 0 35.5 0q-1.25 0-2.15.3-.55.2-.8.4V.6l-.3.2q-3.7 2.7-5.75 9.85-.05.25-.1.45-.9 2.7-2.3 5.4-1.35 2.35-3.15 4.85-1.65 2.2-3.75 4.35l-2 1.9-2.05 1.85-.75.75q-1.7 1.25-3.35 2.45-.1.05-.15.1-1.15.85-2.4 1.65-1.05.65-2.1 1.15-.4.15-.65.35-.25.1-.45.25-.35.15-.65.3-3.2 1.95-2.55 3.1.3.4 1.2.75.55.2 1.1.3 1.1.2 2.25.15v-.05l.1.1q1.1-.05 2.3-.25.5-.1 1.05-.15.4-.1.65-.15.95-.25 1.9-.55 1.1-.35 2.15-.8 1.35-.5 2.7-.9 1.5-.65 2.95-1.4.05-.05.25-.05 1.95-1 3.9-2.05.25-.2.5-.3l.5-.3 1.1-.7q2.05-1.45 3.85-2.9 2.45-2.05 4.65-4 2.35-2.25 4.25-4.45 2.1-2.45 3.7-4.85z"
                    id="ObjFoo065__Symbol_152_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M27.1 2.3q-.15-.5-.55-.95Q25.95.7 24.7.2q-1.15-.4-2.25.05-1 .45-1.45 1.3-1.15 1.5-2.1 4.7l-.05.15q-.25.95-.5 1.75-1 2.65-2.5 5.35-1.4 2.35-3.3 4.85-1.65 2.2-3.65 4.4-.35.25-.6.6Q6 25.5 3.05 27.7q-1.6 1.15-2.4 1.9-.05.1-.6.5-.15.3.05.35 5.6-1.95 10.9-6.9 1.95-1.9 3.95-4.25.6-.75 1.3-1.65 1.05-1.45 2-3.15 1.35-2.35 2.5-5.2 0-.05.05-.1.2-.65.25-.75.1-.3.4-1 .2-.8.35-1.2l.6-1.75q.7-1.7 1.35-2.25.8-.7 2.25-.4.85.25 1.1.45z"
                    id="ObjFoo065__Symbol_153_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M9.65 5.75q-.45-2.6-2.25-4.1Q5.6-.4 3.1.1 3 .05 2.9.1q-.65.2-1.1.75-.4.4-.45.95-.1.7.3 1 .4.3 1.9.15.05.05.1 0Q7.05 2.8 7.4 8.9q0 .9-.05 1.35.05.5-.05 1.05-.6 3.5-3.2 4.45-.15.05-.3.2 0 .05-.05 0-.6.25-1.25.55-.45.2-.85.3Q.2 17.65 0 18.35q-.05.3.15.55 0 .05.1.1.15.1.45.2.35.1 1.35 0 .3-.1.5-.1.65-.1 1.25.1.9.3 1.3 1.6l-.05.05q.3 1.35 1.2 1.6.4.15 1-.2.65-.3 1.2-.4h.05q.05-.05.15 0 .2-.05.25 0 .2 0 .4.1.55.2.9.8.35.65.95.9.45.2.85-.1l.1-.1q.25-.1.35-.45.3-.7 0-1.5-.25-.6-.45-1.15l-.2-.4-1.2-2.1q-.35-1.1-.45-2.75-.1-.9 0-2.25-.05-.55-.15-3.95-.15-2.1-.35-3.15z"
                    id="ObjFoo065__Symbol_151_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M6.65 5.3Q6.1 3.9 5.25 3q-.9-1-1.55-1.1-.35-.05-.8-.05-.8 0-.75-.05-.05 0-.1.05-.2-.05-.45-.15-.85-.3-.6-.85.2-.5.75-.8-.1-.05-.2 0Q.9.25.45.8q-.4.4-.45.95-.1.7.3 1 .4.3 1.9.15.05.05.1 0 3.4-.15 3.75 5.95 0 .9-.05 1.35.05.5-.05 1.05-.6 3.5-3.2 4.45-.15.05-.3.2.95-.35 1.9-.75 1.5-.75 2.25-2.6.15-.4.3-.75.3-1.25.25-3 0-2.05-.5-3.5z"
                    id="ObjFoo065__Symbol_150_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ObjFoo065__Symbol_152_0_Layer0_0_FILL"
                transform="translate(241.65 271.05)"
                id="ObjFoo065__col1n"
            />
            <use
                xlinkHref="#ObjFoo065__Symbol_153_0_Layer0_0_FILL"
                transform="translate(252.75 275.15)"
                id="ObjFoo065__col1l"
            />
            <use
                xlinkHref="#ObjFoo065__Symbol_151_0_Layer0_0_FILL"
                transform="translate(274.2 253.3)"
                id="ObjFoo065__col2n"
            />
            <use
                xlinkHref="#ObjFoo065__Symbol_150_0_Layer0_0_FILL"
                transform="translate(275.55 253.35)"
                id="ObjFoo065__col2d"
            />
        </g></g>
    )
}
export default ObjFoo065
